export const TipiRichiedente = {
	RICORRENTE: 'Ricorrente',
	EREDE_RICORRENTE: 'Erede del Ricorrente',
	PERSONA_GIURIDICA_RAPPRESENTANTE_LEGALE: 'Persona Giuridica/Legale rappresentante di Società/Ditta/Ente',
	PROCURATORE_ANTISTATARIO: 'Procuratore Antistatario',
	EREDE_PROCURATORE_ANTISTATARIO: 'Erede del procuratore antistatario',
	TUTORE_PROCURATORE_LEGALE: 'Tutore/Procuratore legale',
	CURATORE_FALLIMENTARE: 'Curatore Fallimentare',
	ME_MEDESIMO: "Me medesimo"
}
export const CodiceTipiRichiedente = {
	CODICE_RICORRENTE: 'RICORRENTE',
	CODICE_PROCURATORE_ANTISTATARIO: 'ANTISTATARIO',
	CODICE_EREDE_RICORRENTE: 'EREDE_RICORRENTE',
	CODICE_PERSONA_GIURIDICA_RAPPRESENTANTE_LEGALE: 'RAPPR_LEG',
	CODICE_EREDE_PROCURATORE_ANTISTATARIO: 'EREDE_ANTISTATARIO',
	CODICE_TUTORE_PROCURATORE_LEGALE: 'TUT',
	CODICE_CURATORE_FALLIMENTARE: 'CURATORE_FALLIMENTARE',
	CODICE_ME_MEDESIMO: 'ME_MEDESIMO'
}